import type { FontFaceSpec } from '../../types';
import woff2 from '../src/PPMori-ExtraBoldItalicNew.woff2';
import woff from '../src/PPMori-ExtraBoldItalicNew.woff';

export const ppMoriExtraBoldItalic: FontFaceSpec = {
  weight: 800,
  style: 'italic',
  src: [
    { file: woff2, format: 'woff2' },
    { file: woff, format: 'woff' },
  ],
};
